module.exports = __webpack_public_path__ + "static/img/education14.7e08741.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/education14.png
// module id = pP6r
// module chunks = 1